import axios from 'axios'
import { ElLoading } from 'element-plus'
import {isInProdEnvFn, isInShowEnvFn} from '@/mm/utils.js'

function http({ baseURL } = {}) {
  const service = axios.create({
    // manage-admin.chukouplus.com
    baseURL: (() => {
      var res

      var isInProdEnv = isInProdEnvFn()

      if (!isInProdEnv) {
        // 测试环境接口
        res = 'https://ksh.yanfa.chukouplus.com'
      } else {
        // 正式环境接口
        res = 'https://www.chukouplus.com'
      }

      var isInShowEnv = isInShowEnvFn()
      if (isInShowEnv) {
        // 演示环境接口
        res = 'https://manage-admin.show.chukouplus.com'
      }



      if(typeof localStorage !== 'undefined' && localStorage.getItem('isUseLocalPhp')){
        res = 'http://xb.admin.com'
      }


      return res
    })(),
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 600000
  })
  const err = (response, message, duration = 5000) => {
    // 是否跳过，通用错误提示
    if (!response?.config?.skipErrorTips) mm.toast(message, 'error', duration)
  }

  // 请求拦截器
  service.interceptors.request.use(
    (config) => {
      if (config.loading) {
        mm.loading()
      }
      config.url = config.url.replace('/api/', '/ksh/')
      config.headers['authorization'] = (() => {

        var templateId = parseUrl(location.href).params.templateId
        var originType = parseUrl(location.href).params.originType
        var token = parseUrl(location.href).params.token
        var combineTokenName = templateId + originType + 'token'

        if (token) {
          localStorage.setItem(combineTokenName, token)

          var url = new URL(window.location.href)
          var params = new URLSearchParams(url.search)
          params.delete('token')
          url.search = params.toString()
          window.history.replaceState({}, '', url)
        }

        return localStorage.getItem(combineTokenName)
      })()

      // 处理上传进度监听
      if (config.uploadProgress) {
        // 配置上传进度回调
        config.onUploadProgress = (progressEvent) => {
          if (progressEvent.lengthComputable) {
            config.uploadProgress(progressEvent)
          }
        }
      }

      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  let is403 = false
  service.interceptors.response.use(
    (response) => {
      if (response.config.loading) {
        mm.stopLoading()
      }
      const code = parseInt(response.data?.code)
      if (!response.config.noCode && !(code === 200 || code === 204 || code === 20001)) {
        const { message, mesg, msg, error } = response.data
        err(response, error?.[0]?.msg || message || mesg || msg[0]?.msg?.msg || msg)
        if (response.data.code === 401 && !is403) {
          is403 = true
          console.error(message)
        }
        mm.stopLoading()
        return Promise.reject(response.data)
      }
      if (code === 20001) {
        return response
      }
      return response.data || response
    },
    (error) => {
      mm.stopLoading()

      if (error === 'offline') {
        console.error(error)
      } else if (error === 'token timeout') {
        err(error, '授权过期，请重新登录')
        return Promise.reject({ code: -1, msg: error })
      } else if (!error.response && error.message.match('timeout')) {
        err(error, '网络请求超时，请检查您的网络！')
      } else if (!error.response) {
        err(error, '网络故障，请检查您的网络！')
      } else {
        if (error.response.status === 504) {
          err(error.response, `服务器故障! ${error.response.status}`)
        } else if (error.response.status === 404) {
          err(error.response, `地址不存在! ${error.response.status}`)
        } else if (error.response.status === 403) {
          err(error.response, '权限不足,请联系管理员!')
        } else if (error.response.status === 401) {
          ElLoading.service({
            lock: true,
            background: 'rgba(255,255,255,.3)',
            spinner: 'none'
          })
          err(error.response, '未授权，请重新登录')
          setTimeout(() => {
            mm.utils.removeCookie()
            location.reload()
          }, 3000)
        } else {
          try {
            err(error.response, error.response.data.message || error.response.data.error)
          } catch (e) {
            err(error.response, '未知错误!')
          }
        }
      }

      return Promise.reject(error)
    }
  )

  return service.request
}

const httpCase = http()

export default httpCase
